import { APIError } from '../../error'
import { appointmentErrors } from './appointment'
import { attendanceErrors } from './attendance'
import { attendanceFormErrors } from './attendance-form'
import { attendanceShareTokenErrors } from './attendance-share-token'
import { authErrors } from './auth'
import { birdIdErrors } from './bird-id'
import { cepErrors } from './cep'
import { cfmErrors } from './cfm'
import { cityErrors } from './city'
import { cpfCnpjErrors } from './cpfCnpj'
import { diseaseErrors } from './disesase'
import { extensionErrors } from './extension'
import { healthPlanErrors } from './health-plan'
import { kbaErrors } from './kba'
import { kiraErrors } from './kira'
import { lmeAttachmentErrors } from './lmeAttachment'
import { medicalDocumentErrors } from './medical-document'
import { organizationErrors } from './organization'
import { patientErrors } from './patient'
import { physicianErrors } from './physician'
import { physicianAddressErrors } from './physician-address'
import { posologyErrors } from './posology'
import { termErrors } from './term'
import { treatmentErrors } from './treatment'

export class ApiAbortedError extends Error {
  constructor() {
    super('Request aborted')
    this.name = ApiAbortedError.name
    Error.captureStackTrace(this, this.constructor)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export type ErrorBaseData = {
  message: string
  description: string
}

const errorNameMap = {
  ...appointmentErrors,
  ...attendanceFormErrors,
  ...attendanceErrors,
  ...attendanceShareTokenErrors,
  ...authErrors,
  ...birdIdErrors,
  ...cfmErrors,
  ...cityErrors,
  ...cepErrors,
  ...cpfCnpjErrors,
  ...diseaseErrors,
  ...extensionErrors,
  ...healthPlanErrors,
  ...kbaErrors,
  ...kiraErrors,
  ...lmeAttachmentErrors,
  ...medicalDocumentErrors,
  ...organizationErrors,
  ...patientErrors,
  ...physicianAddressErrors,
  ...physicianErrors,
  ...posologyErrors,
  ...termErrors,
  ...treatmentErrors,
}

const errorStatusMap: Record<string, ErrorBaseData> = {
  400: {
    message: 'Dados incompletos. Por favor, tente novamente!',
    description: 'Alguma informação está faltando. Por favor, tente novamente!',
  },
  401: {
    message: 'Necessita autenticação',
    description: 'Faça login e tente novamente',
  },
  403: {
    message: 'Rota Proibida!',
    description: 'Esta rota não pode ser acessada com as credenciais presentes',
  },
  404: {
    message: 'Recurso não encontrado!',
    description: `Não foi possível encontrar o recurso. Verifique as informações e tente novamente!`,
  },
  409: {
    message: 'Houve um erro na API!',
    description: `Não foi possível realizar a operação. Entre em contato com o Suporte!`,
  },
  422: {
    message: 'Aconteceu algum erro ao realizar a ação!',
    description: `Algum erro aconteceu ao realizar a ação. Tente novamente ou entre em contato com o Suporte!`,
  },
  500: {
    message: APIError.messageFallback,
    description: APIError.descriptionFallback,
  },
  503: {
    message: APIError.messageFallback,
    description: 'Não foi possível conectar-se ao servidor! Verifique sua conexão e tente novamente.',
  },
}

export type RawResponseError = {
  error: {
    name: string
    message: string
    cause: Record<string, unknown>
  }
  path: string
  statusCode: number
  timestamp: string
}

export function handleApiError(response: RawResponseError) {
  const mappedError: ErrorBaseData | undefined =
    errorNameMap[response.error.name] ?? errorStatusMap[response.statusCode]

  return new APIError({
    message: mappedError?.message ?? APIError.messageFallback,
    description: mappedError?.description ?? APIError.descriptionFallback,
    code: response.statusCode,
    name: response.error.name,
    cause: response.error.cause,
  })
}
